
    
        var maquetteH = require('maquette').h;
        var h = function(selector, props, children) {
          var attributes = Object.assign({}, props.attributes || {}, props);
          delete attributes["attributes"];

          // This should be done by pug-vdom, oh well...
          if (attributes.class) {
            selector += "." + attributes.class.trim().split(/ +/).join(".");
            delete attributes["class"];
          }

          return maquetteH(selector, attributes, children);
        }
      ;
    function render(context, h, text = (string) => string) {
  if (!pugVDOMRuntime) throw "pug-vdom runtime not found.";
  var runtime = pugVDOMRuntime
  var locals = context;
  var self = locals;
  var remainingKeys = pugVDOMRuntime.enterLocalsScope(locals);
  for (var prop in remainingKeys) {
    eval('var ' + prop + ' =  locals.' + prop);
  }
  var n0Child = []
  var n102Child = []
  var n103Child = []
  var n104Child = []
  n104Child = n104Child.concat(text(this.t('.title')))
  var props = {attributes: runtime.compileAttrs([], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n104 = h('span', props, n104Child)
  n103Child.push(n104)
  var n105Child = []
  var n106Child = []
  var n107Child = []
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'fas'},{name:'class', val: 'fa-plus'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n107 = h('i', props, n107Child)
  n106Child.push(n107)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'icon'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n106 = h('span', props, n106Child)
  n105Child.push(n106)
  var n108Child = []
  n108Child = n108Child.concat(text(this.t('.add')))
  var props = {attributes: runtime.compileAttrs([], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n108 = h('span', props, n108Child)
  n105Child.push(n108)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'button'},{name:'class', val: 'is-small'},{name:'type', val: "button"},{name:'onclick', val: this.onAddClick}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n105 = h('button', props, n105Child)
  n103Child.push(n105)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'panel-heading'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n103 = h('div', props, n103Child)
  n102Child.push(n103)
  var v109 = [...this.assets.values()]
  Object.keys(v109).forEach(function (k110) {
    var asset = v109[k110]
    var n111Child = []
    var n112Child = []
    n112Child = n112Child.concat(text(asset.id.toString()))
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'asset-id'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n112 = h('div', props, n112Child)
    n111Child.push(n112)
    var n113Child = []
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'asset-memo'},{name:'class', val: 'input'},{name:'class', val: 'is-small'},{name:'value', val: asset.memo},{name:'oninput', val: this.onMemoInput.bind(this, asset)},{name:'type', val: "text"},{name:'placeholder', val: this.t('.memo_placeholder')}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n113 = h('input', props, n113Child)
    n111Child.push(n113)
    var n114Child = []
    var n115Child = []
    var props = {attributes: runtime.compileAttrs([{name:'type', val: "checkbox"},{name:'checked', val: asset.autoDelete},{name:'oninput', val: this.onAutoDeleteInput.bind(this, asset)}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n115 = h('input', props, n115Child)
    n114Child.push(n115)
    n114Child.push(text("= this.t('.auto_delete')"))
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'checkbox'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n114 = h('label', props, n114Child)
    n111Child.push(n114)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'panel-block'},{name:'class', val: 'asset'},{name:'id', val: `assets-manager-${asset.id}`}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n111 = h('div', props, n111Child)
    n102Child.push(n111)
  }.bind(this))
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'assets'},{name:'class', val: 'panel'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n102 = h('section', props, n102Child)
  n0Child.push(n102)
  pugVDOMRuntime.exitLocalsScope()
  return n0Child
}
;
    module.exports = function(locals) {
      locals = Object.assign(window.DEFAULT_TEMPLATE_LOCALS || {}, locals || {});
      return render.call(this, locals, h);
    };
  